var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.428,
    height: 16.428,
    viewBox: "0 0 16.428 16.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95,9.167,22.309,7.523,15.741,14.09,9.174,7.523,7.522,9.167l6.567,6.567L7.522,22.3l1.644,1.65,6.567-6.567L22.3,23.951l1.642-1.642-6.567-6.567Z",
    transform: "translate(-7.522 -7.523)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.165378fa5ad98427f95c56bf63d4f1dc.svg";
export { ForwardRef as ReactComponent };